var React = require('react');

function IcHome (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 10.3284V19H4V17C4 14.2386 6.23858 12 9 12C11.7614 12 14 14.2386 14 17V19H16V10.3284L9 3.32843L2 10.3284ZM9 0.5L18 9.5V21H12V17C12 15.3431 10.6569 14 9 14C7.34315 14 6 15.3431 6 17V21H0V9.5L9 0.5Z","fill":"currentColor"}));
}

IcHome.defaultProps = {"viewBox":"0 0 18 21","fill":"none"};

module.exports = IcHome;

IcHome.default = IcHome;
